import { Texture } from "@/core/backends/webgl/texture"
import { Texture3D } from "@/core/backends/webgl/texture-3d"
import { formatDistance } from "date-fns/fp"
import { TextureArray } from "@/core/backends/webgl/texture-array"
import { isPerformanceDebugEnabled } from "./feature-flag"

interface TextureDescriptor {
	texture: Texture | Texture3D | TextureArray
	maxWidth: number
	maxHeight: number
	lastUsedAt: Date
}

export class TextureMemoryCounters {
	private textureDescriptors = new Map<string, TextureDescriptor>()

	public get totalBytesUsage() {
		let totalSize = 0

		this.textureDescriptors.forEach((value) => {
			totalSize += value.texture.getByteLength()
		})

		return totalSize
	}

	public get totalMaxAllocatedBytesUsage() {
		let totalSize = 0

		this.textureDescriptors.forEach((value) => {
			totalSize += value.maxWidth * value.maxHeight * value.texture.getBytesPerPixel()
		})

		return totalSize
	}

	constructor() {}

	add(texture: Texture | Texture3D | TextureArray) {
		if (!isPerformanceDebugEnabled()) {
			return
		}

		this.textureDescriptors.set(texture.id, {
			texture,
			lastUsedAt: new Date(),
			maxHeight: 0,
			maxWidth: 0,
		})
	}

	delete(texture: Texture | Texture3D | TextureArray) {
		if (!isPerformanceDebugEnabled()) {
			return
		}

		this.textureDescriptors.delete(texture.id)
	}

	update(texture: Texture | Texture3D | TextureArray) {
		if (!isPerformanceDebugEnabled()) {
			return
		}

		const descriptor = this.textureDescriptors.get(texture.id)

		if (!descriptor) {
			return
		}

		descriptor.maxWidth = Math.max(descriptor.maxWidth, texture.width)
		descriptor.maxHeight = Math.max(descriptor.maxHeight, texture.height)

		descriptor.lastUsedAt = new Date()
		this.textureDescriptors.set(texture.id, descriptor)
	}

	printUsage() {
		const records = {}

		let totalSize = 0

		this.textureDescriptors.forEach((value) => {
			const label = value.texture.label
			const size = Math.fround(value.texture.getByteLength() / 1024 / 1024)
			const lastUsed = formatDistance(value.lastUsedAt, new Date())
			const format = value.texture.format

			records[label] = {
				"Size (MB)": size,
				Dimensions: `${value.texture.width}x${value.texture.height}`,
				"Max Dimensions": `${value.maxWidth}x${value.maxHeight}`,
				Format: format,
				"Last Used:": lastUsed,
			}

			totalSize += size
		})

		console.table(records)

		console.table({
			Total: {
				"Size (MB)": totalSize,
				Dimensions: "",
				"Max Dimensions": "",
				Format: "",
				"Last Used": "",
			},
		})
	}
}
